import React from 'react';
import { Container } from '@mui/material';
import { IWorkProfile } from '../../types/global/helper';
import { PhotoGrid } from './PhotoGrid';
import { AudioReelGrid } from './AudioReelGrid';
import { useThemeContext } from '../../hook/useThemeManager';
import { DemoReelGrid } from './DemoReelGrid';

export interface IWorkProfileProps {
    workProfile?: IWorkProfile;
}

const Media: React.FC<IWorkProfileProps> = ({ workProfile }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Container sx={{ p: 2 }}>
            <PhotoGrid
                photos={workProfile?.photos}
                onAddPhoto={() => {}}
                columns={10}
                sx={{
                    maxWidth: '100%',
                }}
            />
            <DemoReelGrid themeStyle={themeStyle} projects={workProfile?.demo_reel} />
            <AudioReelGrid sounds={workProfile?.audio_reel} themeStyle={themeStyle} />
        </Container>
    );
};

export { Media };
